import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import LayoutHeader from '../../../../layout/LayoutHeader';
import DizeeInput from '../../../../components/DizeeComponent/DizeeInput';
import { setFocusCustom, clearFocusSection } from '../../../../store/focuspage/focuspageSlice';
import { addCustomForFocusThunk } from '../../../../store/focuspage/focuspageThunk';
import { setErrorAlert, setLoader } from '../../../../store/alert/alertSlice';
import { uploadImage } from '../../../../utils/upload';
import Check from '../../../../svg/Check';
import AddedCustom from '../../../../components/Focuspage/Type/Custom/AddedCustom';
import OverlayCustom from '../../../../components/Focuspage/Type/Custom/OverlayCustom';
import { addCustomForBrandThunk } from '../../../../store/addsection/addsectionThunk';

export default function EditVideoContent1() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation()
    const token = localStorage.getItem('dizeeToken');
    console.log(`location.state::`, location.state);

    const [currentVideo, setCurrentVideo] = useState({
        sectionTitle: location.state.sectionTitle,
        primaryText: location.state.primaryText,
        link: location.state.link,
        image: location.state.avatar,
        preview: location.state.avatar,
        extension: location.state.extension,
        type: 'video'
    });
    const [videoItems, setVideoItems] = useState([]);

    const isValidUrl = (url) => {
        if (!url) return false;
        const tldPattern = /\.[a-z]{1,}$/i;
        try {
            const urlObj = new URL(url);
            return tldPattern.test(urlObj.hostname);
        } catch {
            return false;
        }
    };

    // Only require image for completion
    const isFormComplete = currentVideo.preview;

    const isDoneValid = () => {
        return videoItems.length > 0 || isFormComplete;
    };

    const handleLinkChange = (e) => {
        let value = e.target.value;
        if (value && !value.startsWith('http')) {
            value = `https://${value}`;
        }
        setCurrentVideo({ ...currentVideo, link: value });
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Add file size check
            if (file.size > 5 * 1024 * 1024) { // 5MB limit
                dispatch(setErrorAlert('Image size should be less than 5MB'));
                return;
            }

            const reader = new FileReader();
            reader.onloadend = () => {
                setCurrentVideo({
                    ...currentVideo,
                    image: file,
                    preview: reader.result
                });
            };
            reader.readAsDataURL(file);
            e.target.value = '';
        }
    };

    const handleSubmit = async () => {

        if (!isDoneValid()) {
            dispatch(setErrorAlert('Please add at least one video item'));
            return;
        }

        dispatch(setLoader(true));

        let processedVideos = [];

        try {
            // Process one image at a time instead of Promise.all

            let url = '';
            if (typeof currentVideo.image != "string") {
                url = await uploadImage(currentVideo.image);
                if (!url) {
                    throw new Error('Image cannot contain nudity, violence or drugs');
                }
            } else {
                url = currentVideo.image;
            }

            let data = currentVideo
            delete data.preview;
            processedVideos.push({
                ...data,
                avatar: url
            });

            // Simplify the payload structure
            const dataCopy = processedVideos

            const result = await dispatch(addCustomForBrandThunk({
                token,
                payload: dataCopy
            })).unwrap();

            if (result.status === 200) {
                // dispatch(clearFocusSection());
                navigate("/main");
            } else {
                throw new Error(result.message || 'Failed to create focus page');
            }
        } catch (error) {
            console.error('Error creating custom focus page:', error);
            dispatch(setErrorAlert(error?.message || 'Error creating focus page'));
        } finally {
            dispatch(setLoader(false));
        }
    };

    return (
        <LayoutHeader>
            <div className="flex justify-center w-full">
                <div className="w-[390px] h-[80vh] flex flex-col items-center relative">
                    <div className="w-full flex flex-col flex-1 overflow-y-auto pb-[120px]">
                        <div className="px-4 my-[50px] flex w-full justify-between fixed w-full sm:w-[390px] bg-black z-20">
                            <p className="text-white">Add content</p>
                            <div className="flex gap-[30px]">
                                {/* {isFormComplete && (
                                    <div className="text-white cursor-pointer" onClick={handleAddAnother}>
                                        Another
                                    </div>
                                )} */}
                                <div
                                    className={`text-white cursor-pointer ${!isDoneValid() ? 'opacity-50' : ''}`}
                                    onClick={() => isDoneValid() && handleSubmit()}
                                >
                                    Done
                                </div>
                                <div className="text-white cursor-pointer" onClick={() => navigate(-1)}>
                                    Go back
                                </div>
                            </div>
                        </div>

                        <div className="w-full px-4 mt-[120px] relative z-10">
                            <div className="flex items-center mb-4">
                                <DizeeInput
                                    placeholder="Enter section title (applies to all content)"
                                    onChange={(e) => setCurrentVideo({ ...currentVideo, sectionTitle: e.target.value })}
                                    value={currentVideo.sectionTitle}
                                />
                            </div>

                            <div className="flex flex-col">
                                <div className='flex w-full justify-between items-center' style={{ fontSize: '12px' }}>
                                    <div className='items-center flex flex-row text-white w-full'>
                                        <DizeeInput
                                            placeholder="Enter title"
                                            onChange={(e) => setCurrentVideo({ ...currentVideo, primaryText: e.target.value })}
                                            value={currentVideo.primaryText}
                                        />
                                    </div>
                                </div>

                                <div className='flex w-full justify-between items-center mt-5' style={{ fontSize: '12px' }}>
                                    <div className='items-center flex flex-row text-white w-full'>
                                        <div className="flex items-center w-full">
                                            <DizeeInput
                                                placeholder="Enter link"
                                                onChange={handleLinkChange}
                                                value={currentVideo.link}
                                            />
                                            {isValidUrl(currentVideo.link) && <Check className="h-[12px] w-[18px] ml-2" />}
                                        </div>
                                    </div>
                                </div>

                                <div className="w-full mt-5">
                                    <p
                                        className="text-white text-[12px] mb-2 cursor-pointer"
                                        onClick={() => document.getElementById('file-input').click()}
                                    >
                                        {currentVideo.preview ? 'Change image' : 'Upload image'}
                                    </p>
                                    {currentVideo.preview && (
                                        <div className="w-[50px] h-[50px] rounded-[3px] overflow-hidden">
                                            <img src={currentVideo.preview} alt="preview" className="w-full h-full object-cover" />
                                        </div>
                                    )}
                                    <input
                                        id="file-input"
                                        type="file"
                                        onChange={handleImageChange}
                                        className="hidden"
                                        accept="image/*"
                                    />
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="w-full absolute bottom-0 left-0">
                        <div className="w-full h-[20px] bg-gradient-to-t from-black to-transparent" />
                        <div className="w-full bg-black px-4 py-6">
                            <div className="text-[12px] text-[rgba(255,255,255,0.5)] leading-[1.5] max-w-full">
                                <p>Add your content to display in your focus page.</p>
                                <p>Only an image is required. Add title and link to enhance the presentation.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </LayoutHeader>
    );
} 